module.exports = __webpack_public_path__ + "static/icon_color_green-5b69ee1ab9090c58790f658cedc63bd8.png";